import React from "react";
import List from "./feature/list";

const BulkActivity = () => {
  return <List />;
};
export default BulkActivity;
